<template>
  <div class="lg:flex flex-row md:flex px-3 py-3 bg-teal-400">
    <div class="lg:w-1/3 md:w-1/3 sm:/w-full text-center">
      <h3 class="uppercase text-white font-medium text-lg px-8 py-3">
        angebote & gutscheine
      </h3>
    </div>
    <div class="lg:w-1/3 md:w-1/3 sm:/w-full flex">
      <!-- <form class="flex" @submit.prevent="subscribe"> -->
        <input
          class="p-3 w-full"
          type="email"
          v-model="email"
          required
          placeholder="E-Mail-Adresse hier eingeben"
        />
          <!-- @click="subscribe()" -->
        <button
          class="bg-black text-white uppercase font-medium px-3 hover:text-white hover:bg-teal-400"
        >
          Abonnieren
        </button>
      <!-- </form> -->
    </div>
    <div class="lg:w-1/3 md:w-1/3 sm:/w-full text-center">
      <ul class="inline-flex py-2">
        <li>
          <a
            target="_blank"
            href="https://www.facebook.com/homeface.de"
            class="text-white px-4 text-xl"
          >
            <i class="fab fa-facebook-f"></i>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://twitter.com/homeface_de"
            class="text-white px-4 text-xl"
          >
            <i class="fab fa-twitter"></i>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://homeface.de"
            class="text-white px-4 text-xl"
          >
            <i class="fab fa-google"></i>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://www.instagram.com/homeface.de"
            class="text-white px-4 text-xl"
          >
            <i class="fab fa-instagram"></i>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://www.pinterest.com/homeface"
            class="text-white px-4 text-xl"
          >
            <i class="fab fa-pinterest"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
    };
  },
  methods: {
    subscribe() {
      if (this.email.trim != "") {
        axios
          .post(`${process.env.VUE_APP_API}/subscribe`, {
            email: this.email,
          })
          .then((response) => {
            
            
              (this.email = ""),
              this.$notify({
                group: "cart",
                
                title: "Homeface",
                text: response.data.message,
              })
            
            
            console.log(response);
          })
          .catch((error) => {
            if(error.response.status != 200)
            {
              console.log(error.response.status == 200),
              this.$notify({
                group: "cart",
                title: "Homeface",
                text: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal!",
              })
            }
          });

      }
    },
  },
};
</script>

<style></style>
